export default "__VITE_ASSET__DTnnoVy4__"